<template>
    <div class="success-message">
        <div>
            <van-icon name="success" color="green"/>
        </div>
        <span>{{message}}</span>
    </div>
</template>

<script>
    import { NavBar,Icon } from 'vant';
    import {getKey} from "../utils/url";
    export default {
        data: function () {
            return {
                message: ''
            }
        },
        components: {
            [Icon .name]: Icon ,
            [NavBar.name]: NavBar
        },
        created: async function () {
            this.message = getKey("message");
        }
    };
</script>
<style scoped>
    .success-message{
        text-align: center;
        font-size: 3rem;
        position: relative;
        padding-top: 15rem;
    }
</style>
